import { MAX_ACCOUNT_GROUP_DEPTH } from "@common/constants/domains/accounting/accountGroups";

export const NO_GROUP_VALUE = "__no_group__";

export const NO_GROUP_LABEL = "No group";

export const DEPTH_LIMIT_TOOLTIP = `Selecting this group would nest beyond the maximum of ${MAX_ACCOUNT_GROUP_DEPTH} account-group levels.`;
